export default __webpack_public_path__ + "static/media/icons8-time-span-144.0227e0bb.svg";